import React from 'react';
import Carousel from '@hpstellar/core/Carousel';
import Typography from '@hpstellar/core/Typography';
import Button from '@hpstellar/core/Button';

import withPageComponents from '../../../page/components/with-page-components';

import './hero-banner.less';

const slickSettings = {
    dots: true,
    infinite: true,
    draggable: false,
    arrows: true
}

const heroBanner = ({ heroBanner }) => {
    const { bannerSlides } = heroBanner || {};
    if (  bannerSlides &&  bannerSlides.length > 0) {
        return (<Carousel
               {...slickSettings}
               className={'home-hero'}
            >
                { bannerSlides.map(banner => {
                    return (<div className={'banner'}>
                                <img src={banner.desktopImage}/>
                                <div className='banner-overlay'>
                                    <Typography
                                        tag="h1"
                                        variant="headingTitleLarge"
                                    >
                                     {banner.title}
                                    </Typography>
                                    <Typography variant="bodyLargeRegular">
                                        {banner.text}
                                    </Typography>
                                    <Button 
                                        color={'dark'} 
                                        href={banner.ctaLink}
                                        target="_blank"
                                    >
                                        {banner.cta}
                                    </Button>
                                </div>
                        </div>)
                })}
            </Carousel>);
    }
    return null;
}

export default withPageComponents(heroBanner, { components: ['heroBanner'] })
